export default __webpack_public_path__ + "mini-icon-ios@2x.png";